<template>
  <div class="tutorials-container">
 

    <!-- 模块一：安装指南 -->
    <section class="install-guide">
      <h2>🔧 安装指南</h2>
      <div class="system-requirements">
        <h3>系统要求</h3>
        <ul>
          <li>操作系统：Windows 7 及以上</li>
          <li>内存：至少 8 GB RAM</li>
          
        </ul>
      </div>
      
      <!-- Document链接跳转介绍 -->
      <div class="document-link-section">
        <h3>📚 详细文档</h3>
        <div class="document-card">
          <div class="document-icon">📖</div>
          <div class="document-content">
            <h4>软件详细说明文档</h4>
            <p>包含完整的软件功能介绍、操作指南、参数说明和技术原理，帮助用户深入了解软件的各项功能和使用方法。</p>
            <div class="document-features">
              <div class="feature-item">
                <span class="feature-icon">🔧</span>
                <span>软件功能介绍</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">📋</span>
                <span>操作步骤详解</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">⚙️</span>
                <span>参数配置说明</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">🔬</span>
                <span>技术原理介绍</span>
              </div>
            </div>
            <button class="document-btn" @click="goToDocument">
              📖 查看详细文档
            </button>
          </div>
        </div>
      </div>
      <div class="install-steps">
        <h3>📥 安装步骤</h3>
        <div class="step">
          <div class="text">
            <h4>1. 下载软件</h4>
            <p>访问官网下载页面并选择对应版本进行下载</p>
            <button class="download-btn" onclick="window.location.href='https://atmcorr.com/download'">⬇ 下载软件</button>
          </div>
        </div>
        <div class="step">
          <div class="text">
            <h4>2. 解压安装</h4>
            <p>解压安装包，双击 setup.exe 开始安装</p>
            <div class="step-details">
              <ul>
                <li>确保解压目录有写入权限</li>
                <li>建议使用默认安装路径</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="step">
          <div class="text">
            <h4>3. 完成安装</h4>
            <p>根据提示完成安装，首次启动需联网登录</p>
            <div class="step-details">
              <ul>
                <li>安装过程中请保持网络连接</li>
                <li>首次登录需要注册账号</li>
                <li>登录后即可开始使用</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 技术参数表格迁移自产品案例 -->
      <div class="tech-parameters">
        <h2>技术参数</h2>
        <table>
          <thead>
            <tr>
              <th>参数类别</th>
              <th>内容</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>使用模型</td>
              <td>MODTRAN（最新版，支持多种大气情景、视角、气溶胶模式）</td>
            </tr>
            <tr>
              <td>光谱通道支持</td>
              <td>支持20余颗卫星40个以上光学载荷，包括全色和多波段通道</td>
            </tr>
            <tr>
              <td>辐射校正精度</td>
              <td>反射率误差：（绝对0.03，相对10%）</td>
            </tr>
            <tr>
              <td>处理模式</td>
              <td>一站式全自动，支持批处理</td>
            </tr>
            <tr>
              <td>数据输入</td>
              <td>原始卫星影像</td>
            </tr>
            <tr>
              <td>数据输出</td>
              <td>经过几何校正后的地表反射率遥感影像产品</td>
            </tr>
            <tr>
              <td>数据格式支持</td>
              <td>Geotiff格式</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- 模块二：操作步骤 -->
    <section class="operation-steps">
      <h2>⚙ 主要步骤</h2>
      <div class="steps-grid">
        <div class="step-card">
          <div class="step-content">
            <div class="step-text">
              <h4>1. 辐射定标</h4>
              <p>对原始影像进行辐射定标，生成表观辐亮度图像。</p>
              <div class="step-details">
                <h5>输入数据：</h5>
                <ul>
                  <li>原始卫星影像</li>
                  <li>定标系数文件</li>
                </ul>
                <h5>输出结果：</h5>
                <ul>
                  <li>表观辐亮度图像</li>
                  <li>定标参数报告</li>
                </ul>
              </div>
            </div>
            <div class="step-image">
              <img src="@/assets/liucheng.png" alt="辐射定标流程图" />
            </div>
          </div>
        </div>
        <div class="step-card">
          <div class="step-content">
            <div class="step-text">
              <h4>2. 大气校正</h4>
              <p>基于MODTRAN模型进行大气参数估计，生成地表反射率图像。</p>
              <div class="step-details">
                <h5>主要参数：</h5>
                <table>
                  <thead><tr><th>参数名</th><th>含义</th><th>说明</th></tr></thead>
                  <tbody>
                    <tr><td>大气模型</td><td>MODTRAN</td><td>支持多种大气情景</td></tr>
                    <tr><td>气溶胶模式</td><td>自定义</td><td>根据实际大气状况选择</td></tr>
                    <tr><td>能见度</td><td>自动/手动</td><td>可自动估算或手动输入</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="step-image">
              <img src="@/assets/liucheng.png" alt="大气校正流程图" />
            </div>
          </div>
        </div>
        <div class="step-card">
          <div class="step-content">
            <div class="step-text">
              <h4>3. 几何校正</h4>
              <p>使用元数据与DEM文件完成影像配准，输出带坐标的产品。</p>
              <div class="step-details">
                <h5>处理内容：</h5>
                <ul>
                  <li>影像配准</li>
                  <li>投影转换</li>
                  <li>DEM校正</li>
                </ul>
                <h5>输出格式：</h5>
                <ul>
                  <li>GeoTIFF</li>
                  <li>带地理坐标信息</li>
                </ul>
              </div>
            </div>
            <div class="step-image">
              <img src="@/assets/liucheng.png" alt="几何校正流程图" />
            </div>
          </div>
        </div>
        <div class="step-card">
          <div class="step-content">
            <div class="step-text">
              <h4>4. 一站式处理</h4>
              <p>集成多个处理步骤，实现从原始数据到最终产品的全流程处理。</p>
              <div class="step-details">
                <h5>输入数据：</h5>
                <ul>
                  <li>原始卫星影像</li>
                  <li>定标系数文件</li>
                  <li>XML元数据文件</li>
                  <li>RGB真彩色文件</li>
                </ul>
                <h5>处理参数：</h5>
                <table>
                  <thead><tr><th>参数类型</th><th>选项</th><th>说明</th></tr></thead>
                  <tbody>
                    <tr><td>卫星载荷</td><td>多选</td><td>支持多种卫星传感器</td></tr>
                    <tr><td>能见度</td><td>自动/手动</td><td>可自动估算或手动输入</td></tr>
                    <tr><td>大气类型</td><td>多种模型</td><td>根据实际大气状况选择</td></tr>
                    <tr><td>气溶胶模型</td><td>多种模式</td><td>支持多种气溶胶类型</td></tr>
                    <tr><td>空间分辨率</td><td>自定义</td><td>可设置输出影像分辨率</td></tr>
                  </tbody>
                </table>
                <h5>输出结果：</h5>
                <ul>
                  <li>经过辐射定标、大气校正和几何校正的影像</li>
                  <li>处理参数报告</li>
                  <li>质量控制报告</li>
                </ul>
              </div>
            </div>
            <div class="step-image">
              <img src="@/assets/liucheng.png" alt="一站式处理流程图" />
            </div>
          </div>
        </div>

        <!-- 5. 图像融合 -->
        <div class="step-card">
          <div class="step-content">
            <div class="step-text">
              <h4>5. 图像融合</h4>
              <p>实现全色与多光谱影像的有效快速融合，提升空间与光谱分辨率的一致性。</p>
              <div class="step-details">
                <h5>处理原理：</h5>
                <p>通过主成分变换（PCA）、Brovey、Gram-Schmidt（GS）、高通滤波（HPF）等多种算法，将高分辨率的全色影像与多光谱影像在空间与光谱域中进行加权融合，实现空间细节增强与光谱保持。</p>
                <h5>输入数据：</h5>
                <ul>
                  <li>多光谱影像（MS）</li>
                  <li>全色影像（PAN）</li>
                  <li>传感器元数据（XML 文件）</li>
                </ul>
                <h5>主要参数：</h5>
                <table>
                  <thead><tr><th>参数名</th><th>含义</th><th>说明</th></tr></thead>
                  <tbody>
                    <tr><td>融合算法</td><td>算法选择</td><td>支持 PCA、Brovey、IHS、GS、HPF 等方法</td></tr>
                    <tr><td>输出分辨率</td><td>空间分辨率</td><td>默认与全色一致，可自定义</td></tr>
          
                  </tbody>
                </table>
                <h5>输出结果：</h5>
                <ul>
                  <li>融合影像（GeoTIFF 格式）</li>
                </ul>
              </div>
            </div>
            <!-- <div class="step-image">
              <img src="@/assets/liucheng.png" alt="图像融合流程图" />
            </div> -->
          </div>
        </div>

        <!-- 6. 图像镶嵌 -->
        <div class="step-card">
          <div class="step-content">
            <div class="step-text">
              <h4>6. 图像镶嵌</h4>
              <p>根据经纬度和坐标控制点信息，实现多景影像的无缝拼接与光度均衡。</p>
              <div class="step-details">
                <h5>处理原理：</h5>
                <p>通过影像重采样、重叠区域加权、灰度匹配与边缘羽化等算法，消除拼接缝与亮度差异，生成连续的区域影像产品。</p>
                <h5>输入数据：</h5>
                <ul>
                  <li>多景影像</li>
                </ul>
                <h5>主要参数：</h5>
                <table>
                  <thead><tr><th>参数名</th><th>含义</th><th>说明</th></tr></thead>
                  <tbody>
                    <tr><td>拼接方式</td><td>控制方法</td><td>支持自动拼接 / 手动控制点拼接</td></tr>
                    <tr><td>匹配算法</td><td>亮度匹配</td><td>支持直方图匹配、线性归一化等</td></tr>
                    <tr><td>羽化宽度</td><td>边缘平滑</td><td>控制接缝区域平滑范围</td></tr>
                  </tbody>
                </table>
                <h5>输出结果：</h5>
                <ul>
                  <li>无缝拼接影像（GeoTIFF 格式）</li>
                </ul>
              </div>
            </div>
            <!-- <div class="step-image">
              <img src="@/assets/liucheng.png" alt="图像镶嵌流程图" />
            </div> -->
          </div>
        </div>

        <!-- 7. 批处理 -->
        <div class="step-card">
          <div class="step-content">
            <div class="step-text">
              <h4>7. 批处理</h4>
              <p>支持多景全色与多光谱影像的自动辐射定标、大气校正及融合批量化处理。</p>
              <div class="step-details">
                <h5>处理原理：</h5>
                <p>通过多线程与任务队列管理，实现对大规模影像数据的自动化处理流程；支持断点续传、日志记录及质量监控。</p>
                <h5>输入数据：</h5>
                <ul>
                  <li>影像文件夹路径</li>
                  <li>批处理任务配置文件（JSON / XML 格式）</li>
                </ul>
                <h5>处理参数：</h5>
                <table>
                  <thead><tr><th>参数类型</th><th>选项</th><th>说明</th></tr></thead>
                  <tbody>
                    <tr><td>处理模块</td><td>可选</td><td>辐射定标 / 大气校正 / 几何校正 / 融合</td></tr>
                    <tr><td>并行模式</td><td>单机 / 多核</td><td>支持 CPU 多线程并行处理</td></tr>
                  </tbody>
                </table>
                <h5>输出结果：</h5>
                <ul>
                  <li>批量处理后的校正或融合影像</li>
                </ul>
              </div>
            </div>
            <!-- <div class="step-image">
              <img src="@/assets/liucheng.png" alt="批处理流程图" />
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 模块三：软件概述 -->
    <section class="software-overview">
      <h2>🧰 软件概述</h2>
      <div class="overview-columns">
        <div class="column">
          <h3>🛠 功能介绍</h3>
          <p>支持多源遥感影像大气校正、几何校正等功能。</p>
        </div>
        <div class="column">
          <h3>🌍 应用场景</h3>
          <p>城市监测、农业遥感、灾害评估、土地利用等。</p>
        </div>
        <div class="column">
          <h3>🚀 技术优势</h3>
          <p>高精度校正、快速批处理、支持多平台部署。</p>
        </div>
      </div>
    </section>

    <!-- 模块四：案例展示 -->
    
  </div>
</template>

<script>
export default {
  name: 'Tutorials',
  methods: {
    goToDocument() {
      // 跳转到Document页面
      this.$router.push('/document');
    }
  }
};
</script>

<style scoped>
.tutorials-container {
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Orbitron', sans-serif;
  color: var(--text-primary);
  background: var(--bg-dark);
  position: relative;
  overflow: hidden;
}

.tutorials-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 50% 50%, rgba(0, 180, 255, 0.1) 0%, transparent 50%),
    linear-gradient(45deg, rgba(0, 247, 255, 0.05) 25%, transparent 25%),
    linear-gradient(-45deg, rgba(255, 0, 255, 0.05) 25%, transparent 25%);
  background-size: 100% 100%, 60px 60px, 60px 60px;
  background-position: center center, 0 0, 0 0;
  pointer-events: none;
  z-index: 0;
}

section {
  padding: 40px 20px;
  background: var(--card-bg);
  margin-bottom: 20px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  backdrop-filter: blur(10px);
}

h2 {
  margin-bottom: 20px;
  border-left: 5px solid var(--primary);
  padding-left: 10px;
  color: var(--primary);
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

p {
  margin-top: 26px;
  color: var(--text-secondary);
}

.install-steps .step {
  background: var(--card-bg);
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
  margin-bottom: 20px;
  transition: all 0.3s;
}

.install-steps .step:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.2);
}

.install-steps .step h4 {
  color: var(--primary);
  font-size: 20px;
  margin-bottom: 15px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.install-steps .step p {
  color: var(--text-secondary);
  margin-bottom: 15px;
  line-height: 1.6;
}

.install-steps .step-details {
  margin-top: 15px;
  padding: 15px;
  background: rgba(0, 180, 255, 0.05);
  border-radius: 6px;
  border: 1px solid rgba(0, 180, 255, 0.1);
}

.install-steps .step-details ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

.install-steps .step-details li {
  color: var(--text-secondary);
  margin: 8px 0;
  padding-left: 20px;
  position: relative;
  line-height: 1.4;
}

.install-steps .step-details li::before {
  content: '•';
  color: var(--primary);
  position: absolute;
  left: 0;
}

.download-btn {
  background: var(--quantum-glow);
  color: var(--text-primary);
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s;
  margin-top: 15px;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 15px var(--primary);
}

/* 技术参数与流程模块 */
.tech-parameters {
  background: var(--card-bg);
  padding: 30px;
  border-radius: 8px;
  margin-bottom: 40px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
}

.tech-parameters h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: var(--primary);
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.tech-parameters table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.tech-parameters th,
.tech-parameters td {
  border: 1px solid rgba(0, 180, 255, 0.2);
  padding: 12px;
  text-align: left;
  font-size: 14px;
  color: var(--text-secondary);
}

.tech-parameters th {
  background: rgba(0, 180, 255, 0.1);
  color: var(--text-primary);
}

.tech-parameters tr:nth-child(even) {
  background: rgba(0, 180, 255, 0.05);
}

.tech-parameters tr:hover {
  background: rgba(0, 180, 255, 0.1);
}

.steps-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.step-content {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.step-text {
  flex: 1;
}

.step-image {
  flex: 1;
  min-width: 300px;
}

.step-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  filter: brightness(0.8) contrast(1.2);
  transition: all 0.3s;
}

.step-image img:hover {
  transform: scale(1.02);
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.2);
}

.step-card {
  flex: 1 1 100%;
  min-width: 300px;
  background: var(--card-bg);
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s;
  margin-bottom: 20px;
}

.step-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.2);
}

.step-card h4 {
  color: var(--primary);
  font-size: 20px;
  margin-bottom: 15px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.step-card p {
  color: var(--text-secondary);
  margin-bottom: 20px;
  line-height: 1.6;
}

.step-details {
  margin-top: auto;
  padding: 20px;
  background: rgba(0, 180, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(0, 180, 255, 0.1);
}

.step-details h5 {
  color: var(--primary);
  margin: 15px 0 10px;
  font-size: 16px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.3);
}

.step-details h5:first-child {
  margin-top: 0;
}

.step-details ul {
  list-style-type: none;
  padding-left: 0;
  margin: 10px 0;
}

.step-details li {
  color: var(--text-secondary);
  margin: 8px 0;
  padding-left: 20px;
  position: relative;
  line-height: 1.4;
}

.step-details li::before {
  content: '•';
  color: var(--primary);
  position: absolute;
  left: 0;
}

.step-details table {
  width: 100%;
  margin: 10px 0;
  border-collapse: collapse;
}

.step-details th,
.step-details td {
  padding: 12px;
  text-align: left;
  border: 1px solid rgba(0, 180, 255, 0.2);
}

.step-details th {
  background: rgba(0, 180, 255, 0.1);
  color: var(--text-primary);
}

.step-details td {
  color: var(--text-secondary);
}

.step-details tr:nth-child(even) {
  background: rgba(0, 180, 255, 0.05);
}

.step-details tr:hover {
  background: rgba(0, 180, 255, 0.1);
}

.overview-columns {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.column {
  flex: 1;
  background: var(--card-bg);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s;
}

.column:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.2);
}

.column h3 {
  color: var(--primary);
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
  margin-bottom: 15px;
}

.column p {
  color: var(--text-secondary);
  line-height: 1.6;
}

.case-grid {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.case-card {
  flex: 1 1 calc(33.333% - 20px);
  background: var(--card-bg);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s;
}

.case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.2);
}

.case-card img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  filter: brightness(0.8) contrast(1.2);
  border: 1px solid rgba(0, 180, 255, 0.2);
}

.case-card .tag {
  background: rgba(0, 180, 255, 0.2);
  color: var(--text-primary);
  padding: 4px 8px;
  margin: 4px;
  border-radius: 4px;
  display: inline-block;
  border: 1px solid rgba(0, 180, 255, 0.3);
}

.case-card button {
  margin-top: 10px;
  background: var(--quantum-glow);
  color: var(--text-primary);
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.case-card button:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 15px var(--primary);
}

table {
  width: 45%;
  border-collapse: collapse;
  margin-top: 10px;
  border: 1px solid rgba(0, 180, 255, 0.2);
}

th, td {
  border: 1px solid rgba(0, 180, 255, 0.2);
  padding: 12px;
  text-align: left;
  color: var(--text-secondary);
}

th {
  background: rgba(0, 180, 255, 0.1);
  color: var(--text-primary);
}

tr:nth-child(even) {
  background: rgba(0, 180, 255, 0.05);
}

tr:hover {
  background: rgba(0, 180, 255, 0.1);
}

/* Document链接样式 */
.document-link-section {
  margin: 30px 0;
}

.document-link-section h3 {
  color: var(--primary);
  margin-bottom: 20px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.document-card {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: var(--card-bg);
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.document-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 30px rgba(0, 180, 255, 0.2);
}

.document-icon {
  font-size: 48px;
  color: var(--primary);
  text-shadow: 0 0 15px rgba(0, 180, 255, 0.5);
  flex-shrink: 0;
}

.document-content {
  flex: 1;
}

.document-content h4 {
  color: var(--primary);
  font-size: 20px;
  margin-bottom: 15px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.document-content p {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 20px;
}

.document-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: rgba(0, 180, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(0, 180, 255, 0.1);
  transition: all 0.3s ease;
}

.feature-item:hover {
  background: rgba(0, 180, 255, 0.1);
  transform: translateX(5px);
}

.feature-icon {
  font-size: 18px;
  color: var(--primary);
}

.feature-item span:last-child {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
}

.document-btn {
  background: var(--quantum-glow);
  color: var(--text-primary);
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 180, 255, 0.2);
}

.document-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 180, 255, 0.4);
  background: linear-gradient(135deg, var(--primary), var(--secondary));
}

/* 响应式设计 */
@media (max-width: 768px) {
  .document-card {
    flex-direction: column;
    text-align: center;
  }
  
  .document-icon {
    font-size: 36px;
  }
  
  .document-features {
    grid-template-columns: 1fr;
  }
  
  .feature-item {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .document-card {
    padding: 20px;
  }
  
  .document-content h4 {
    font-size: 18px;
  }
  
  .document-btn {
    width: 100%;
    padding: 15px;
  }
}

.install-steps .step {
  margin-top: 26px;
  color: var(--text-secondary);
}

</style>
